<template>
    <common-select v-model="selected" :placeholder="placeholder" @change="updateValue" :multiple="multiple " :options="options" :clearable="clearable"></common-select>
</template>

<script lang="ts">
    import { defineComponent, ref } from "vue";

    export default defineComponent({
        props: {
            value: {
                type: Number, default: null,
            },
            placeholder: {
                type: String, default: "",
            },
            code: {
                type: String, default: "",
            },
            multiple: {
                type: Boolean, default: false,
            },
            clearable: {
                type: Boolean, default: false,
            }
        },
        emits: ["update:value"],
        setup(props, { emit }) {
            const selected = ref(props.value);
            const options = ref(Array);
            watch(
                () => props.value,
                (newValue) => {
                    selected.value = newValue;
                }
            );
            watch(
                () => selected,
                (newValue) => {
                    emit("update:value", newValue);
                }
            );
            const updateValue = (value: number) => {
                emit("update:value", value);
                emit("change", value);
            };
            const { systemData } = useSystemStore();
            options.value = systemData.enums.find(k => k.code == props.code)?.items.filter(k=>k.id)

            return {
                selected,
                options,
                updateValue
            };
        },
    });
</script>
